/**
 * The product surface a given LLM call belongs to, recorded on every
 * `llm_usage` row.
 *
 * Several features share the same two models, so the model alone cannot say
 * where spend is going — this label is what makes the admin breakdown
 * actionable. Values are stable identifiers: renaming one splits its history
 * in the usage table, so add a new entry rather than editing an existing value.
 */
export const LLM_USAGE_FEATURES = {
  ScriptGeneration: 'script-generation',
  ScriptEdit: 'script-edit',
  TopicRecommendations: 'topic-recommendations',
  SetGeneration: 'set-generation',
  StoryboardBeats: 'storyboard-beats',
  StoryboardImage: 'storyboard-image',
  ScriptReview: 'script-review',
  ScriptMatch: 'script-match',
  ScriptExtraction: 'script-extraction',
  RejectionSuggestion: 'rejection-suggestion',
  PersonaAvatar: 'persona-avatar',
  PersonaScriptGeneration: 'persona-script-generation',
  PersonaScriptImport: 'persona-script-import',
  PersonaBriefGeneration: 'persona-brief-generation',
  PersonaBriefEdit: 'persona-brief-edit',
  ChangelogNotes: 'changelog-notes',
  ChangelogDigest: 'changelog-digest',
  PromptCatalog: 'prompt-catalog',
} as const;

export type LlmUsageFeature = (typeof LLM_USAGE_FEATURES)[keyof typeof LLM_USAGE_FEATURES];

export const LLM_USAGE_FEATURE_VALUES = Object.values(LLM_USAGE_FEATURES) as LlmUsageFeature[];

export function isLlmUsageFeature(value: string): value is LlmUsageFeature {
  return (LLM_USAGE_FEATURE_VALUES as string[]).includes(value);
}
